const tools = {
  Circle: "circle",
  Line: "line",
  Arrow: "arrow",
  Pencil: "pencil",
  Highlight: "highlight",
  Rectangle: "rectangle",
  RectangleLabel: "rectangleLabel",
  Select: "select",
  Pan: "pan",
  DottedLine: "dottedLine",
  Eraser: "eraser",
  EraserAll: "eraserAll",
  Text: "text",
  Link: "link",
  DefaultTool: "defaultTool",
  None: "none",
  HideOfPart: "hideOfPart",
  IsoPartOfScreen: "isoPartOfScreen",
};

export default tools;
